// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"bd8d8df4","150":"546ecfbd","389":"f359551f","716":"e927b244","787":"7ea8c378","859":"d3ec8c9d","933":"b4a10dda"}[chunkId] + ".chunk.js";
};